import React, {Component} from "react";
import {Spinner, Button} from "react-bootstrap";
import '../../App.css';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {Navigate} from "react-router-dom"
import {AppContext} from "../../AppContext";
import axios from "axios";
import DbUser from "../../queries/DbUser";


const defaultSorted = [{
    dataField: 'id',
    order: 'desc'
}];

const {SearchBar} = Search;

const searchProps = {
    delay: 800,
    placeholder: "wpisz aby wyszukać",
};

const sizePerPageRenderer = ({
                                 options,
                                 currSizePerPage,
                                 onSizePerPageChange
                             }) => (
    <div className="btn-group" role="group">
        {
            options.map((option) => {
                const isSelect = currSizePerPage === `${option.page}`;
                return (
                    <button
                        key={option.text}
                        type="button"
                        onClick={() => onSizePerPageChange(option.page)}
                        className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                    >
                        {option.text}
                    </button>
                );
            })
        }
    </div>
);

const options = {
    sizePerPageRenderer
};

class CustomerList extends Component {

    static contextType = AppContext;

    state = {
        data: [],
        isDataLoaded: false,
        edit: false,
        redirect: ''
    }

    componentDidMount() {
        DbUser.getLoggedUser(this.context)

        axios.get(`${this.context.hostname}/api/customer/findAll`, {
            headers: {"X-Requested-With": "XMLHttpRequest"},
            withCredentials: true,
        }).then(res => {
            if (res.status = 200) {
                this.setState({
                    data: res.data,
                    isDataLoaded: true
                })
            }
        })
            .catch((error) => {
                console.log(error)
            });

        // fetch(`${this.context.hostname}/api/customer/findAll`, {
        //     method: 'POST',
        //     headers: {
        //         'email': `${this.context.login}`,
        //         'password': `${this.context.password}`
        //     }
        // })
        //     .then(response => response.json())
        //     .then(data => {
        //         this.setState({
        //             data: data,
        //             isDataLoaded: true
        //         })
        //     });
    }

    handleBackOnClick = () => {
        this.setState({redirect: '/home'})
    }

    render() {
        const onClickEvent = {

            onClick: (e, column, columnIndex, row, rowIndex) => {
                console.log(row.province)
                var province = row.province;
                // window.location.href = `/customerEdit?id=${row.id}&shortName=${row.shortName.replace("&", "%26")}&fullName=${row.fullName.replace("&", "%26")}&streetAddress=${row.streetAddress.replace("&", "%26")}&zipCode=${row.zipCode.replace("&", "%26")}&city=${row.city.replace("&", "%26")}&nip=${row.nip.replace("&", "%26")}&regon=${row.regon.replace("&", "%26")}&phoneNumber=${row.phoneNumber.replace("&", "%26")}&email=${row.email.replace("&", "%26")}`;
                const link = `/customerEdit?id=${row.id}&shortName=${row.shortName.replaceAll("&", "%26")}&fullName=${row.fullName.replaceAll("&", "%26")}&streetAddress=${row.streetAddress.replaceAll("&", "%26")}&zipCode=${row.zipCode.replaceAll("&", "%26")}&city=${row.city.replaceAll("&", "%26")}&province=${province}&nip=${row.nip.replaceAll("&", "%26")}&regon=${row.regon.replaceAll("&", "%26")}&phoneNumber=${row.phoneNumber.replaceAll("&", "%26")}&email=${row.email.replaceAll("&", "%26")}`
                this.setState({redirect: link})
            }
        }

        const columns = [{
            dataField: 'id',
            text: 'id',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'shortName',
            text: 'Nazwa',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'fullName',
            text: 'Pełna nazwa',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'streetAddress',
            text: 'Ulica',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'zipCode',
            text: 'Kod pocztowy',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'city',
            text: 'Miasto',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'province',
            text: 'Województwo',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'nip',
            text: 'NIP',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'regon',
            text: 'REGON',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'phoneNumber',
            text: 'TELEFON',
            sort: true,
            events: onClickEvent,
        }, {
            dataField: 'email',
            text: 'e-mail',
            sort: true,
            events: onClickEvent,
        }];


        if (this.state.edit === true) {
            return (<Navigate to="/customerEdit"/>)
        }


        return (
            <div className="fragment">
                {this.context.redirectToLoginPage ? <Navigate to="/login"/> : ''}
                {this.state.redirect != '' ? <Navigate to={this.state.redirect}/> : ''}
                <ToolkitProvider
                    bootstrap3
                    keyField="id"
                    data={this.state.data}
                    columns={columns}
                    defaultSorted={defaultSorted}
                    bordered={false}
                    noDataIndication=""
                    search>
                    {
                        props => (
                            <div>
                                <h3>
                                    <Button variant="light" onClick={this.handleBackOnClick}>
                                        <svg width="1em" height="1em" viewBox="0 0 16 16"
                                             className="bi bi-arrow-return-left"
                                             fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                  d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"/>
                                        </svg>
                                    </Button>
                                    &nbsp;Lista kontrahentów
                                    <Button
                                        className="float-end"
                                        variant="outline-dark"
                                        onClick={() => this.setState({redirect: '/customerAdd'})}>
                                        +
                                    </Button>
                                </h3>

                                <SearchBar
                                    {...props.searchProps}
                                    placeholder="Wpisz aby wyszukać..."
                                />
                                <hr/>
                                <BootstrapTable
                                    bootstrap3
                                    keyField="id"
                                    data={this.state.data}
                                    columns={columns}
                                    defaultSorted={defaultSorted}
                                    bordered={false}
                                    noDataIndication=""
                                    pagination={paginationFactory(options)}
                                    {...props.baseProps}
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                {!this.state.isDataLoaded &&
                <div className={"container"} style={{textAlign: "center"}}><Spinner animation="border"/></div>}
            </div>
        )
    }
}

export default CustomerList;
